import image1 from '~/assets/images/may-giat-toshiba-aw.jpg'
import image2 from '~/assets/images/redmi-note-12-turbo-1.jpg'
import image3 from '~/assets/images/tv-xiaomi-es-ea.jpg'
import image4 from '~/assets/images/xiaomi_14_Pro_15.jpg'
import acerLogo from '~/assets/images/acer_logo.jpg'
import appleLogo from '~/assets/images/apple_logo.png'
import dellLogo from '~/assets/images/dell_logo.png'
import huaweiLogo from '~/assets/images/huawei_logo.webp'
import oppoLogo from '~/assets/images/oppo_logo.png'
import panasonicLogo from '~/assets/images/panasonic.png'
import realmeLogo from '~/assets/images/realme_logo.png'
import rogLogo from '~/assets/images/rog_logo.jpg'
import samsungLogo from '~/assets/images/samsung_logo.png'
import vivoLogo from '~/assets/images/vivo_logo.png'
import xiaomiLogo from '~/assets/images/xiaomi_logo.png'

export const SlideImages = [image1, image2, image3, image4]

export const brandsLogo = [
	acerLogo,
	appleLogo,
	dellLogo,
	huaweiLogo,
	oppoLogo,
	panasonicLogo,
	realmeLogo,
	rogLogo,
	samsungLogo,
	vivoLogo,
	xiaomiLogo,
]
